<template>
  <div class="section-container">
    <div class="section-title">产品</div>
    <div class="section-desc">核心宗旨：让医疗器械的生意更容易做、更高效、更合规、更安全。</div>

    <div class="card_container">
      <div
        class="brain_item"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_icon" :class="{'green-icon': item.isGreen}">
          <i :class="item.icon"></i>
        </div>
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_navigate" @click="handleNavigate(item.title)">了解详情 >></div>
        <div class="item_bg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          title: '上下游协同管理',
          desc: '通过信息共享、资源整合和流程优化，实现供应链上下游企业间的高效协作与整体效益最大化。',
          link: '/production/1',
          icon: 'el-icon-connection',
          isGreen: false
        },
        {
          title: '经销商授权管理',
          desc: '通过资质审核、授权发放，规范经销商经营行为并维护品牌市场秩序的管理体系。',
          link: '/production/dealer-auth',
          icon: 'el-icon-document-checked',
          isGreen: true
        },
        {
          title: '经销商经营管理系统',
          desc: '集采购、销售、库存、财务、管理于一体的数字化工具，帮助企业高效管控经销网络并提升渠道运营效率。',
          link: '/production/dealer-manage',
          icon: 'el-icon-office-building',
          isGreen: false
        },
        {
          title: '高值耗材手术跟台管理',
          desc: '对手术中使用的高值耗材进行全程跟踪、精准配送和实时记录，确保耗材使用合规、可追溯的管理流程。',
          link: '/production/surgery-track',
          icon: 'el-icon-first-aid-kit',
          isGreen: true
        },
        {
          title: '数据分析管理',
          desc: '通过系统化采集、处理和分析数据，为决策提供科学依据。',
          link: '/production/data-analysis',
          icon: 'el-icon-data-analysis',
          isGreen: false
        },
        {
          title: '经销商经营质量管理系统',
          desc: '符合新版质量管理规范，加强企业经营合规性，实现经营全过程可追溯。',
          link: '/production/dealer-quality',
          icon: 'el-icon-medal',
          isGreen: true
        },
        {
          title: 'AI智能运营管理',
          desc: '利用人工智能技术实现数据驱动决策、流程优化，提升运营效率和智能化水平。',
          link: '/production/ai-operation',
          icon: 'el-icon-cpu',
          isGreen: false
        }
      ],
    }
  },
  methods: {
    handleNavigate(title) {
      const item = this.cardList.find(item => item.title === title);
      if (item && item.link) {
        this.$router.push(item.link);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section-container {
  // 确保移动端有足够的顶部间距
  @media screen and (max-width: 768px) {
    padding-top: 20px;
  }
  
  .card_container {
    width: 90%;
    max-width: 1200PX;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 20PX;
    padding: 10PX;
    position: relative;
    z-index: 1;

    .brain_item:nth-child(-n+3) {
      grid-column: span 4;
    }

    .brain_item:nth-child(n+4) {
      grid-column: span 3;
    }

    @media screen and (max-width: 1200PX) {
      .brain_item {
        grid-column: span 4 !important;
      }
    }

    @media screen and (max-width: 992PX) {
      .brain_item {
        grid-column: span 6 !important;
      }
    }

    @media screen and (max-width: 768PX) {
      width: 95%;
      .brain_item {
        grid-column: span 12 !important;
      }
      gap: 15PX;
      padding: 5PX;
    }
  }

  .brain_item {
    background: #fff;
    border-radius: 16PX;
    box-shadow: 0 4PX 12PX 0 rgba(24, 144, 255, 0.08);
    padding: 20PX;
    position: relative;
    min-height: 210PX;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    overflow: hidden;

    &:hover {
      transform: translateY(-5PX);
      box-shadow: 0 8PX 24PX 0 rgba(24, 144, 255, 0.15);
      
      .item_bg {
        opacity: 1;
      }

      .item_title {
        color: #fff;
        transform: translateY(-2PX);
      }

      .item_desc {
        color: rgba(255, 255, 255, 0.85);
        transform: translateY(-2PX);
      }

      .item_icon {
        i {
          color: #fff !important;
        }
      }

      .item_navigate {
        background: #fff;
        color: #1890ff;
        transform: translateY(-2PX);
      }
    }

    .item_icon {
      position: absolute;
      top: 20PX;
      right: 20PX;
      z-index: 2;
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

      i {
        font-size: 48PX;
        color: #1890ff;
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        display: block;
      }

      &.green-icon i {
        color: #52c41a;
      }
    }

    .item_title {
      font-size: 18PX;
      font-weight: bold;
      color: #333333;
      text-align: left;
      padding: 0 0 12PX 0;
      padding-right: 60PX;
      position: relative;
      z-index: 2;
      transition: all 0.3s ease;
      margin-top: 25PX;
    }

    .item_desc {
      color: #666666;
      text-align: left;
      line-height: 1.5;
      position: relative;
      z-index: 2;
      font-size: 14PX;
      flex-grow: 1;
      margin-bottom: 12PX;
      transition: all 0.3s ease;
    }

    .item_navigate {
      width: 100PX;
      height: 32PX;
      background: #1890ff;
      color: #fff;
      border-radius: 16PX;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13PX;
      cursor: pointer;
      z-index: 2;
      position: relative;
      align-self: flex-end;
      transition: all 0.3s ease;
    }

    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(134deg, #1890ff 0%, #40a9ff 50%, #69c0ff 100%);
      opacity: 0;
      transition: all 0.4s ease;
      border-radius: 16PX;
      z-index: 1;
    }

    @media screen and (max-width: 768PX) {
      min-height: 200PX;
      padding: 15PX;

      .item_icon {
        top: 15PX;
        right: 15PX;

        i {
          font-size: 42PX;
        }
      }

      .item_title {
        font-size: 16PX;
        padding: 0 0 10PX 0;
        padding-right: 50PX;
        margin-top: 20PX;
      }

      .item_desc {
        font-size: 13PX;
        line-height: 1.5;
        margin-bottom: 10PX;
      }

      .item_navigate {
        width: 90PX;
        height: 28PX;
        font-size: 12PX;
      }
    }
  }
}

.todo_show_wrap {
  
  .card_title {
    font-size: $h3-font-size;
    font-weight: $font-weight-semibold;
    color: $text-color-primary;
    margin-bottom: 16px;
  }
  
  .card_desc {
    font-size: $font-size-base;
    line-height: $line-height-base;
    color: $text-color-secondary;
    @include multi-line-ellipsis(3);
  }
  
  .todo_card {
    padding: 24px;
    height: 100%;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      
      .card_title {
        color: $primary-blue;
      }
    }
  }
  
  @media (max-width: $screen-md) {
    .card_title {
      font-size: $h4-font-size;
    }
    
    .card_desc {
      font-size: $font-size-sm;
    }
  }
}
</style>